<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'app',
}
</script>

<style>
#app {
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
}
.btn:focus,
.b-calendar .b-calendar-grid {
  box-shadow: none !important;
  outline: none !important;
}
.b-form-btn-label-control.form-control > .dropdown-menu{
  transform: translate3d(0px, 30px, 0px) !important;
}
label{
  margin-bottom: 8px;
}
.b-form-btn-label-control.form-control > .btn{
    display: none !important;
}

.vue-simple-progress{
    position: relative !important;
}

.required{
  border: 1px solid #D85067 !important;
}
.bar-container{
    position: absolute !important;
    bottom: 5%;
    left: 5%;
    width: 80%;
}
.currencyBtn{
    border: 1px solid #000;
    border-radius: 50px;
    height: 25px;
}
.currencyBtn input[type="radio"]{
    appearance: none !important;
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
}
.currencyBtn .btn-secondary,
.currencyBtn .btn-secondary:focus,
.currencyBtn .btn-secondary:hover{
    color: rgba(0, 0, 0, 1);
}
.currencyBtn .btn.btn-secondary{
    background: transparent !important;
    border: none;
    padding-top: 0;
    padding-bottom: 0;
}
.currencyBtn .btn-secondary.active{
    color: #fff;
    background: #000 !important;
    border-radius: 50px !important;
    height: 23px;
} 

.currencyBtn .btn-secondary.active:focus,
.currencyBtn .btn-secondary.active:hover{
    color: #fff;
    background: #000 !important;
} 
.date-picker-input.form-control{
  padding: 0 !important;
}
.mx-input{
  border: none !important;
  border-radius: 0 !important;
  width: 100;
  box-shadow: none !important;
  height: 36px !important;
}
.mx-input::placeholder{
    color: rgba(0, 0, 0, 0.3) !important;
}

.mx-input:focus{
    border:1px solid #000 !important;
} 

.date-picker-input label{
    color: rgba(0, 0, 0, 1) !important;
}
.disable.date-picker-input label{
    color: rgba(0, 0, 0, 0.3) !important;
}

.custom-file, .custom-file-input {
    position: relative;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
}

.custom-file {
    display: inline-block;
    margin-bottom: 0;
}
.required.custom-file {
  border: none !important;
}
.required.custom-file .custom-file-label{
  border: 1px solid #D85067;
}
.custom-file-input {
    z-index: -5;
    margin: 0;
    overflow: hidden;
    opacity: 0;
}
.custom-file-label, .custom-file-label:after {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0.375rem 0.75rem;
    line-height: 1.5;
    color: rgba(0, 0, 0, 0.3);
}

.active .custom-file-label, .active .custom-file-label:after {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0.375rem 0.75rem;
    line-height: 1.5;
    color: rgba(0, 0, 0, 1);
}

.custom-file-label {
    left: 0;
    z-index: 1;
    height: calc(1.5em + 0.75rem + 2px);
    overflow: hidden;
    font-weight: 400;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 0;
}
.custom-file-label {
    white-space: nowrap;
    overflow-x: hidden;
}
.form-control::placeholder{
    color: rgba(0, 0, 0, 0.3);
}

.custom-file-input:focus + .custom-file-label{
    border: 1px solid #000;
}

.custom-control-label:before, .custom-file-label, .custom-select {
    transition: background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

.btn-back,
.btn-back:focus,
.btn-back:hover{
  color: #000;
  text-decoration: none;
  padding-top: 7px;
  display: inline-block;
}
.btn-back{
  white-space: nowrap;
}
.b-calendar-grid-body .btn-primary.active{
  background-color: #AF00B1 !important;
  border-color: #AF00B1 !important;
}
select {
  -moz-appearance: none;
   -webkit-appearance: none;
   appearance: none;
   background-image: url('./assets/img/icn_dropdown.svg');
   background-position: calc(100% - 20px) center;
   background-size: 10px;
   background-repeat: no-repeat;
}
select:focus {
  -moz-appearance: none;
   -webkit-appearance: none;
   appearance: none;
   background-image: url('./assets/img/icn_arrowup.svg');
   background-position: calc(100% - 20px) center;
   background-size: 10px;
   background-repeat: no-repeat;
}
@media (max-width: 1600px) {
	label, 
  .custom-select,
  .form-control,
  .date-picker-input label,
  .form-control::placeholder {
      font-size: 13px !important;
  }
}
@media (max-width: 1400px) {
	.custom-select{
      padding-right: 40px !important;
  }
}

@media (max-width: 767px){
  .sm-none{
    display: none;
  }
  .mx-input{
    height: 45.5px !important;
  }
}

@media (min-width: 1600px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
      max-width: 1520px !important;
  }
}

@media (min-width: 1800px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
      max-width: 1720px !important;
  }
  .bar-container{
      width: 75%;
  }
}
</style>
